import React from 'react'
import _ from 'lodash'
import { Icon, Label, Menu, Input } from 'semantic-ui-react'

export default class SelectDriverField extends React.PureComponent {
  state = { searchValue: '' }

  renderDrivers = () => {
    const { drivers } = this.props
    const { searchValue } = this.state

    const foundDrivers = _.filter(drivers, driver => {
      const searchNameValue = `${driver.family_name} ${driver.first_name}`
      const searchTelValue = driver.tel

      return (
        searchNameValue.toLowerCase().search(searchValue) !== -1 ||
        searchTelValue.toLowerCase().search(searchValue) !== -1
      )
    })

    return _.map(foundDrivers, driver => {
      return this.renderRow(driver)
    })
  }

  renderRow = driver => {
    const { selectedDrivers, onSelectDriver } = this.props

    return (
      <Menu.Item
        key={driver.driverUID}
        active={_.includes(selectedDrivers, driver.driverUID)}
        onClick={() => onSelectDriver(driver.driverUID)}
        style={{ padding: '13px 10px', borderRadius: 0 }}
      >
        <div
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            display: 'flex',
          }}
        >
          <Label color={driver.online ? 'green' : 'red'}>
            {driver.online ? 'Online' : 'Offline'}
          </Label>
          <Label
            size="large"
            style={{
              marginRight: 5,
              width: 120,
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            {driver.driverUID}
          </Label>
          <div
            style={{
              whiteSpace: 'normal',
              wordBreak: 'break-all',
              lineHeight: '1.3',
              display: 'flex',
              flex: 1,
              fontSize: 15,
            }}
          >
            {`${driver.family_name} ${driver.first_name}`}
          </div>
          {_.includes(selectedDrivers, driver.driverUID) && (
            <div
              style={{
                display: 'flex',
                width: 20,
                justifyContent: 'flex-end',
                marginLeft: 5,
              }}
            >
              <Icon name="check" color="green" />
            </div>
          )}
        </div>
      </Menu.Item>
    )
  }

  render() {
    return (
      <Menu vertical style={{ maxHeight: 400, overflow: 'auto', width: 500 }}>
        <Menu.Item key="header" header style={{ padding: 10 }}>
          <div
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              display: 'flex',
            }}
          >
            <div style={{ display: 'flex', flex: 1 }}>List of Drivers</div>
            <div style={{ display: 'flex' }}>
              <Input
                type="text"
                placeholder="Search"
                name="search-driver"
                onChange={e =>
                  this.setState({
                    searchValue: e.target.value.toLowerCase().trim(),
                  })
                }
                icon="search"
                style={{ height: 30, width: 200 }}
              />
            </div>
          </div>
        </Menu.Item>
        {this.renderDrivers()}
      </Menu>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/fields/selectDriver.js